import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: {
      marginBottom: 20,
    },
    modal: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 500,
      height: '100%',
      margin: 'auto',
    },
    header: {
      padding: theme.spacing(4),
      paddingBottom: theme.spacing(1),
      position: 'relative',
      '& .oyster-logo': {
        height: 30,
      },
    },
    close: {
      position: 'absolute',
      top: theme.spacing(3),
      right: theme.spacing(3),
      width: 24,
      height: 24,
      background: '#DFDFDF',
      '& .MuiSvgIcon-root': {
        fontSize: '1.2rem',
        color: theme.oysterTheme.cotton,
      },
    },
    content: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
    },
    section: {
      flex: 1,
      width: '50%',
      flexDirection: 'column',
      padding: theme.spacing(2),
      borderRight: `solid 1px ${theme.oysterTheme.stone}`,
      '&:last-child': {
        borderRight: 'none',
      },
      '&.loading': {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    price: {
      margin: 0,
      lineHeight: 1,
      fontSize: 32,
      paddingLeft: 20,
      '&::before': {
        width: 30,
        position: 'absolute',
        content: '"$"',
        display: 'block',
        fontWeight: 400,
        marginLeft: -20,
        fontSize: 26,
      },
    },
    info: {
      whiteSpace: 'pre-line',
      display: 'inline-block',
      color: theme.oysterTheme.shark,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
    },
    verified: {
      fontSize: 12,
      fontWeight: 600,
      color: theme.oysterTheme.shark,
    },
    icons: {
      flex: 1,
      flexDirection: 'row',
      display: 'inline-flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      gap: '1em',
      '& .brand': {
        '&.visa': {
          height: 15,
        },
        '&.mastercard': {
          height: 25,
        },
        '&.amex': {
          height: 20,
        },
      },
    },
    redirecting: {
      whiteSpace: 'pre-line',
      maxWidth: 200,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '16px',
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 14,
    },
    progress: {
      color: ({ primaryColor }) => `${primaryColor} !important`,
    },
  }),
);

export default useStyles;
